export const LOCALES = ["zh-CN", "en-US"];
export const BRAND = {
    zh: "小田田仓库",
    en: "Elliot's Secret Vault",
};
export const SHARE_THEMES = ["cinematic-vault", "cyber-transfer"];
export const DEFAULT_SHARE_THEME = "cinematic-vault";
export function isLocale(value) {
    return value === "zh-CN" || value === "en-US";
}
export function isShareTheme(value) {
    return value === "cinematic-vault" || value === "cyber-transfer";
}
//# sourceMappingURL=index.js.map